__turbopack_context__.v({
  "action": "aiman-phone-preview-module__ByxRlG__action",
  "actionSpin": "aiman-phone-preview-module__ByxRlG__actionSpin",
  "agent": "aiman-phone-preview-module__ByxRlG__agent",
  "agentLabel": "aiman-phone-preview-module__ByxRlG__agentLabel",
  "camera": "aiman-phone-preview-module__ByxRlG__camera",
  "choice": "aiman-phone-preview-module__ByxRlG__choice",
  "choiceList": "aiman-phone-preview-module__ByxRlG__choiceList",
  "darkPhone": "aiman-phone-preview-module__ByxRlG__darkPhone",
  "feedback": "aiman-phone-preview-module__ByxRlG__feedback",
  "inlineLauncher": "aiman-phone-preview-module__ByxRlG__inlineLauncher",
  "input": "aiman-phone-preview-module__ByxRlG__input",
  "launcher": "aiman-phone-preview-module__ByxRlG__launcher",
  "launcherFloat": "aiman-phone-preview-module__ByxRlG__launcherFloat",
  "logo": "aiman-phone-preview-module__ByxRlG__logo",
  "messageContent": "aiman-phone-preview-module__ByxRlG__messageContent",
  "messages": "aiman-phone-preview-module__ByxRlG__messages",
  "notice": "aiman-phone-preview-module__ByxRlG__notice",
  "noticeBody": "aiman-phone-preview-module__ByxRlG__noticeBody",
  "payment": "aiman-phone-preview-module__ByxRlG__payment",
  "paymentLink": "aiman-phone-preview-module__ByxRlG__paymentLink",
  "phone": "aiman-phone-preview-module__ByxRlG__phone",
  "root": "aiman-phone-preview-module__ByxRlG__root",
  "selectedReply": "aiman-phone-preview-module__ByxRlG__selectedReply",
  "spinner": "aiman-phone-preview-module__ByxRlG__spinner",
  "suggestion": "aiman-phone-preview-module__ByxRlG__suggestion",
  "suggestionMenu": "aiman-phone-preview-module__ByxRlG__suggestionMenu",
  "suggestions": "aiman-phone-preview-module__ByxRlG__suggestions",
  "tap": "aiman-phone-preview-module__ByxRlG__tap",
  "visitor": "aiman-phone-preview-module__ByxRlG__visitor",
});
